import { replaceToken } from "../private/helpers";
// Returns functions that can be used in styled-components interpolations
export var typographyHelper = key => _ref => {
  var {
    theme
  } = _ref;
  return (theme == null ? void 0 : theme.typography[key]) || {};
};
export var paletteHelper = key => _ref2 => {
  var {
    theme
  } = _ref2;
  return theme ? replaceToken(theme.palette, key) : key;
};
export var spacingHelper = key => _ref3 => {
  var {
    theme
  } = _ref3;
  return theme ? replaceToken(theme.spacing, key) : key;
};
export var mediaQueryHelper = query => _ref4 => {
  var {
    theme
  } = _ref4;
  if (!theme) return query;
  if (query in theme.layoutMediaQueries) return theme.layoutMediaQueries[query];else return "@media only screen and " + query;
};